// extracted by mini-css-extract-plugin
module.exports = {"goalinfo":"singlesdgicon_goalinfo__2zuAd","icon":"singlesdgicon_icon__1EwZ8"};